import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "defined-order-container" }
const _hoisted_2 = { class: "defined-order-table" }
const _hoisted_3 = { class: "editable-contents__header" }
const _hoisted_4 = { class: "editable-contents__header-content-wrapper" }
const _hoisted_5 = { class: "header-label header-label--new-order-output" }
const _hoisted_6 = { class: "header-label header-label--recommend-status" }
const _hoisted_7 = { class: "header-label header-label--recommend-date" }
const _hoisted_8 = { class: "header-label header-label--recommend-value" }
const _hoisted_9 = { class: "header-label header-label--recommend-cross-date" }
const _hoisted_10 = { class: "header-label header-label--memo" }
const _hoisted_11 = {
  key: 0,
  class: "editable-contents__content editable-contents-item"
}
const _hoisted_12 = { class: "editable-contents-item__recommend-date--zero-match" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "editable-contents-item__content-wrapper" }
const _hoisted_16 = { class: "editable-contents-item__content-wrapper" }
const _hoisted_17 = { class: "editable-contents-item__recommend-date" }
const _hoisted_18 = { class: "editable-contents-item__content-wrapper" }
const _hoisted_19 = { class: "editable-contents-item__content-wrapper" }
const _hoisted_20 = {
  key: 6,
  class: "editable-contents-item__trash-button--zero-match"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "partial-delivery-contents-item__content-wrapper" }
const _hoisted_23 = { class: "partial-delivery-contents-item__content-wrapper" }
const _hoisted_24 = { class: "partial-delivery-contents-item__recommend-date" }
const _hoisted_25 = { class: "partial-delivery-contents-item__content-wrapper" }
const _hoisted_26 = { class: "partial-delivery-contents-item__content-wrapper" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "defined-order-button-container" }
const _hoisted_29 = {
  key: 0,
  class: "defined-order-container__button-area"
}

import { computed, inject, nextTick, onMounted, reactive, ref, watch } from 'vue';

import { i18n } from '@/i18n';

import { IRecommendOrderArrival } from '@/recommendOrderModule/domains/entities/recommendOrderArrival';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';

import RecommendOrderField from '@/recommendOrderModule/pages/RecommendOrderField.vue';
import SelectOrderStatusField from '../components/SelectOrderStatusField.vue';

import { simpleCopy } from '@/utils/deepCopy';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { nullOrUndefinedToMinusOne } from '@/coreDomainsModule/extends/number';
import { key } from './useRecommendOrderStore';
import { IRecommendOrderArrivalForRecommendEdit } from './interfaces/recommendOrder';
import { TableContentViewModel } from '@/viewModels/tableContent';
import { openConfirmModal } from '@/corePagesModule/components/modal/modalActions';
import { OrderStatusService } from '../domains/services/orderStatusService';
import { IArrival, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import TableMemoButton from '@/corePagesModule/tableMemoButton/TableMemoButton.vue';
import { convertIDateToDateFormat } from '@/corePagesModule/BaseTableContent/utils/dateFormat';
import { RecommendService } from '../domains/services/recommendService';
import { DISPLAY_VALUE_OF_RECOMMENDED_ORDER_DATE_WHEN_NULL, RECOMMENDED_ORDER_DATE_WHEN_NULL } from '../constants';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';

/**
 * uiState
 */
interface IRecommendEdit {
  recommendOrderForms: IRecommendOrderArrivalForRecommendEdit[]; // 推奨発注量
  partialDeliveryForms: IArrival[]; // 分納情報
  checkedIndex: number[];
}

/**
 * recommendの状態
 */
type RecommendState = 'fetched' | 'zeroMatch' | 'error';


export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendEditDefinedOrder',
  props: {
    recommendOrderForms: {},
    partialDeliveryForms: {},
    checkedIndex: {},
    scrollPosition: { default: () => ({ x: 0, y: 0 }) }
  },
  emits: ["changedCheckBoxState", "registeredRecommendOrder"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emits = __emit;

// style variables

//変数
const t = i18n.t;
const vm = new TableContentViewModel();

const store = inject(key);

if (!store) {
  throw new Error('store is undefined');
}

const state: IRecommendEdit = reactive<IRecommendEdit>({
  recommendOrderForms: [],
  partialDeliveryForms: [],
  checkedIndex: [],
}) as IRecommendEdit;

const tableRef = ref<HTMLDivElement | null>(null);

__expose({
  tableRef: tableRef,
});

// イベントフック
onMounted(async () => {
  // amountが0未満のものは除外する
  state.recommendOrderForms = simpleCopy(props.recommendOrderForms).filter((item) => item.amount >= 0);
  state.partialDeliveryForms = simpleCopy(props.partialDeliveryForms);
  state.checkedIndex = state.recommendOrderForms
    .map((item, index) => {
      if (item.isChecked) {
        return index;
      }
      return -1;
    })
    .filter((index) => index !== -1);

  await nextTick(() => {
    if (!tableRef.value) return;
    tableRef.value.scrollTop = props.scrollPosition.y;
  });
});

//computed
const recommendState = computed(() => {
  let result: RecommendState = 'error';
  if (!state.recommendOrderForms) {
    result = 'error';
  } else if (state.recommendOrderForms.length > 0 && state.recommendOrderForms[0].amount >= 0) {
    result = 'fetched';
  } else {
    result = 'zeroMatch';
  }
  return result;
});

watch(
  () => props.recommendOrderForms,
  (newVal) => {
    // amountが0未満のものは除外する
    state.recommendOrderForms = simpleCopy(newVal).filter((item) => item.amount >= 0);
    state.checkedIndex = state.recommendOrderForms
      .map((item, index) => {
        if (item.isChecked) {
          return index;
        }
        return -1;
      })
      .filter((index) => index !== -1);
  }
);

watch(
  () => props.partialDeliveryForms,
  (newVal) => {
    state.partialDeliveryForms = simpleCopy(newVal);
  }
);

watch(
  () => props.checkedIndex,
  (newVal) => {
    state.checkedIndex = simpleCopy(newVal);
  }
);

/**
 * 選択中の推奨発注を取得する
 */
const checkedRecommendOrderForms = computed(() => {
  return state.recommendOrderForms.filter((item, index) => {
    return state.checkedIndex.includes(index);
  });
});

/**
 * crossDateを取得する
 * @param index -index
 */
const getRecommendCrossDate = (index: number): Date | undefined => {
  // 24-02-27 新規追加分は空欄にしたいので、今日の日付ではなくundefinedを返させる
  return store.getRecommendCrossDate(index);
};

/**
 * 分納情報の納入日を取得する
 * @param recommendIndex - 推奨発注のインデックス
 * @param partialDeliveryIndex - 分納情報のインデックス
 */
const getPartialDeliveryCrossDate = (recommendIndex: number, partialDeliveryIndex: number): Date | undefined => {
  // 分納情報の納入日を取得する
  return store.getPartialDeliveryCrossDate(recommendIndex, partialDeliveryIndex);
};

/**
 * メモを取得する
 * @param index - index
 */
const getRecommendOrderNote = (index: number): string | undefined => {
  return store.getRecommendOrderNote(index);
};

/**
 * 推奨発注納期を更新する
 * @param index -index
 * @param updateDate -updateDate
 */
const setCrossDate = (index: number, updateDate: Date) => {
  if (store.state.recommend[index].orderGroupId) {
    showInfoModal({
      modalTitle: t('この発注は発注グループに属しています'),
      modalDescription: t('発注グループに属している発注の納期をこの画面から編集することはできません。発注一覧ページでご確認ください。'),
      backButtonLabel: 'OK',
      icon: 'error',
      colorStyle: 'error',
      enableOutsideClick: false,
      isDisabledNextButton: true,
    });
    return;
  }
  state.recommendOrderForms[index].crossDate = DateService.convertDateToIDate(updateDate);
  store.state.recommend[index].crossDate = DateService.convertDateToIDate(updateDate);

  if (OrderStatusService.shouldCalculateCreatedOrderDate(state.recommendOrderForms[index].status ?? OrderStatus.Recommended)) {
    // 発注日を計算してセットする
    const orderDate = RecommendService.calculateRecommendedCreateOrderDate(state.recommendOrderForms[index]);
    state.recommendOrderForms[index] = {
      ...state.recommendOrderForms[index],
      year: orderDate.year,
      month: orderDate.month,
      day: orderDate.day,
    };
    store.state.recommend[index] = {
      ...store.state.recommend[index],
      year: orderDate.year,
      month: orderDate.month,
      day: orderDate.day,
    };
  }

  if (isCreatableOrder(state.recommendOrderForms[index])) {
    // 発注確定可能な状態で納期を変更した場合、自動でチェックを入れる
    changedCheckBoxState(true, index);
  }
};

/**
 * テキストを変更する
 * @param e -error
 * @param index -index
 */
const changeText = (e: string, index: number) => {
  state.recommendOrderForms[index].amount = nullOrUndefinedToMinusOne(e);
  store.state.recommend[index].amount = nullOrUndefinedToMinusOne(e);

  if (isCreatableOrder(state.recommendOrderForms[index])) {
    // 発注確定可能な状態で数量を変更した場合、自動でチェックを入れる
    changedCheckBoxState(true, index);
  }
};

/**
 * シミュレーションを更新する
 */
const dispatchUpdateSimulate = () => {
  // シミュレーションの開始点を求める（仕様だと、ロックされている or 確定発注の最後の要素のcrossDateを基準にする）
  const lockedRecommend = state.recommendOrderForms.filter((item) => item.isLocked || item.arrivalId != '') ?? [];
  const lockedRecommendLast = lockedRecommend?.[lockedRecommend?.length - 1];

  const startDate = store.calculateStartDate(lockedRecommendLast);

  // ロックされている要素がある場合のみ、シミュレーションを更新する
  if (startDate) {
    store.updateExtraSimulate(undefined, undefined, undefined, lockedRecommend, startDate);
  } else {
    store.updateExtraRecommend(state.recommendOrderForms);
  }
};

/**
 * 推奨発注を固定する
 * @param index -index
 */
const dispatchLockRecommend = (index: number) => {
  store.lockRecommend(index);
  // 0~indexまでロックする
  for (let i = 0; i <= index; i++) {
    state.recommendOrderForms[i].isLocked = true;
  }

  dispatchUpdateSimulate();
};

/**
 * 推奨発注の固定を解除する
 * @param index -index
 */
const dispatchUnLockRecommend = (index: number) => {
  store.unLockRecommend(index);
};

/**
 * ゴミ箱アイコンの表示
 * (自分がlockされている＾自分より後にlockされている発注推奨がある時) | 確定済みの発注でない場合
 * @param index - index
 */
const visibleTrashBox = (index: number) => {
  let isVisible = false;
  if (!state.recommendOrderForms[index].isLocked) return false;
  if (state.recommendOrderForms[index].arrivalId !== '') return false; // arrivalIdが存在する場合は確定済みの発注
  state.recommendOrderForms.forEach((recommend, recommendIndex) => {
    if (recommendIndex > index && recommend.isLocked) isVisible = true;
  });
  return isVisible;
};

/**
 * 推奨発注を削除する
 * @param index -index
 */
const dispatchTrashRecommend = async (index: number) => {
  if (OrderStatusService.isUserConfirmationRequiredForDelete(state.recommendOrderForms[index].status ?? OrderStatus.Recommended)) {
    const result = await openConfirmModal('question', '承認済みの発注を削除しますか？', '削除する', 'キャンセル');
    if (!result.isConfirmed) return;
  }
  store.trashRecommend(index);
  state.recommendOrderForms.splice(index, 1);
  dispatchUpdateSimulate();
};

/**
 * 発注ステータスを更新する
 * @param index -index
 * @param status -status
 */
const updateOrderStatus = (index: number, status: OrderStatus) => {
  // 間の推奨発注を削除するとindexがずれるため、削除後のindexで対象を参照する
  let targetIndex = index;
  if (OrderStatusService.shouldLockOrderWhenUpdateOrderStatus(status)) {
    // 選択されたステータスが「推奨」以外の場合
    state.recommendOrderForms[index].isLocked = true;
    store.state.recommend[index].isLocked = true;
    // 既存発注との間にある推奨発注を削除し、ステータスを変更した発注が既存発注の次に並ぶようにする
    const { updatedForms, removedIndices } = store.removeRecommendedOrdersBeforeIndex(index, state.recommendOrderForms);
    state.recommendOrderForms = simpleCopy(updatedForms);
    store.removeRecommendByIndices(removedIndices);
    state.checkedIndex = state.checkedIndex
      .filter((checkedIndex) => !removedIndices.includes(checkedIndex))
      .map((checkedIndex) => checkedIndex - removedIndices.filter((removedIndex) => removedIndex < checkedIndex).length);
    targetIndex = index - removedIndices.filter((removedIndex) => removedIndex < index).length;

    // 推奨発注日をnullにする
    state.recommendOrderForms[targetIndex] = {
      ...state.recommendOrderForms[targetIndex],
      // 年月日のnull時の値
      ...RECOMMENDED_ORDER_DATE_WHEN_NULL,
    };
    store.state.recommend[targetIndex] = {
      ...store.state.recommend[targetIndex],
      // 年月日のnull時の値
      ...RECOMMENDED_ORDER_DATE_WHEN_NULL,
    };
  }
  state.recommendOrderForms[targetIndex].status = status;
  store.state.recommend[targetIndex].status = status;

  if (isCreatableOrder(state.recommendOrderForms[targetIndex])) {
    // 発注確定可能な状態でステータスを変更した場合、自動でチェックを入れる
    changedCheckBoxState(true, targetIndex);
  }

  // シミュレーションを更新する
  dispatchUpdateSimulate();
};

/**
 * 推奨発注を追加する
 */
const addRecommend = () => {
  const newRecommend = store.addRecommend();
  state.recommendOrderForms.push(simpleCopy(newRecommend));
};

/**
 * チェックボックスの状態に変化があった場合の操作
 * @param isChecked - チェックを付けたか外したか
 * @param rowNumber - チェックボックスに変更が加えられた行の番号
 */
const changedCheckBoxState = (isChecked: boolean, rowNumber: number | undefined) => {
  if (rowNumber != undefined) {
    if (isChecked) {
      state.checkedIndex.push(rowNumber);
      state.recommendOrderForms[rowNumber].isChecked = true;
      store.state.recommend[rowNumber].isChecked = true;
    } else {
      state.checkedIndex = state.checkedIndex.filter((id) => id !== rowNumber);
      state.recommendOrderForms[rowNumber].isChecked = false;
      store.state.recommend[rowNumber].isChecked = false;
    }
  }
  emits('changedCheckBoxState', state.checkedIndex);
};

/**
 * メモの値を更新する
 * @param index -index
 * @param memoText -memoText
 */
const updateMemoValue = (index: number, memoText: string) => {
  state.recommendOrderForms[index].memoText = memoText;
  store.updateRecommendMemoValue(index, memoText);
};

/**
 * 推奨発注日を取得する
 * @param item -item
 */
const getRecommendOrderDate = (item: IRecommendOrderArrival | IArrival) => {
  const orderDate = vm.getRecommendOrderDate(item);
  return orderDate
    ? convertIDateToDateFormat(DateService.convertDateToIDate(orderDate), 'YYYY/MM/DD')
    : DISPLAY_VALUE_OF_RECOMMENDED_ORDER_DATE_WHEN_NULL;
};

/**
 * 推奨発注数量を取得する
 * @param item -item
 */
const getOrderAmount = (item: IRecommendOrderArrival | IArrival) => {
  return item.amount;
};

/**
 * 発注を確定できるかどうか
 * @param item - item
 */
const isCreatableOrder = (item: IRecommendOrderArrival) => {
  return item.status !== undefined && item.crossDate !== undefined && item.amount > 0;
};

/**
 * 発注を確定する
 */
const confirmRecommend = async () => {
  const result = await store.confirmRecommend(simpleCopy(checkedRecommendOrderForms.value));
  if (result.status.type === 'success') {
    // 発注確定後は、チェックボックスを全て外す
    state.checkedIndex = [];
    state.recommendOrderForms.forEach((item) => {
      item.isChecked = false;
    });
    store.state.recommend.forEach((item) => {
      item.isChecked = false;
    });
    emits('registeredRecommendOrder');
  }
};

/**
 * 戻るボタンを押した際の処理
 */
const onClickCancelButton = () => {
  if (!tableRef.value) return;
  tableRef.value.scrollTop = 0;
  store.state.progress = 'EditReceiveAnnounce';
  store.resetOnlyRecommendOrder();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "tableRef",
        ref: tableRef,
        class: "defined-order-container__editable-contents editable-contents"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('発注出力(詳細ページ)')), 1),
            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "header-label header-label--expand" }, _toDisplayString(''), -1)),
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)('発注ステータス(詳細ページ)')), 1),
            _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('発注日(詳細ページ)')), 1),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)('発注数量(詳細ページ)')), 1),
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('納期(詳細ページ)')), 1),
            _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)('メモ(詳細ページ)')), 1),
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "header-label header-label--lock" }, _toDisplayString(''), -1)),
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "header-label header-label--trash" }, _toDisplayString(''), -1))
          ])
        ]),
        (recommendState.value === 'zeroMatch')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(RowCheckBox, {
                modelValue: state.checkedIndex,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.checkedIndex) = $event)),
                class: "editable-contents-item__check-box--zero-match",
                value: false,
                "is-checked": false
              }, null, 8, ["modelValue"]),
              _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1)),
              _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('推奨発注なし')), 1),
              _createVNode(RecommendOrderField, {
                class: "editable-contents-item__recommend-order-value--zero-match",
                "input-type": 'recommendValue',
                "text-value": _unref(t)('推奨発注なし'),
                "label-name": ''
              }, null, 8, ["text-value"]),
              _createVNode(RecommendOrderField, {
                class: "editable-contents-item__cross-date--zero-match",
                "input-type": 'recommendNone',
                "text-value": _unref(t)('推奨発注なし'),
                "label-name": ''
              }, null, 8, ["text-value"]),
              _cache[7] || (_cache[7] = _createElementVNode("div", null, null, -1)),
              _createVNode(SvgLoader, {
                class: "editable-contents-item__lock-button--zero-match",
                name: 'lockClose',
                "data-testid": "`lock_icon`",
                "tool-tip-value": _unref(t)('入力値の固定を解除する(詳細ページ)')
              }, null, 8, ["tool-tip-value"]),
              _createVNode(SvgLoader, {
                class: "editable-contents-item__trash-button--zero-match",
                name: 'trash-box',
                "data-testid": "`trash_box_icon`",
                "tool-tip-value": _unref(t)('項目を破棄する(詳細ページ)')
              }, null, 8, ["tool-tip-value"])
            ]))
          : _createCommentVNode("", true),
        (recommendState.value === 'fetched')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.recommendOrderForms, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.displayId || `index-${index}`
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-contents__content editable-contents-item", { 'locked-item': item.isLocked }])
                  }, [
                    _createVNode(RowCheckBox, {
                      modelValue: state.checkedIndex,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.checkedIndex) = $event)),
                      class: "editable-contents-item__check-box",
                      value: item[index],
                      "is-checked": state.checkedIndex.includes(index),
                      onChangeStatus: ($event: any) => (changedCheckBoxState($event, index))
                    }, null, 8, ["modelValue", "value", "is-checked", "onChangeStatus"]),
                    (item.status === _unref(OrderStatus).PartialDelivery && !item.isExpanded)
                      ? (_openBlock(), _createBlock(SvgLoader, {
                          key: 0,
                          class: "editable-contents-item__expand-button",
                          name: 'arrowRight',
                          "data-testid": "`expand_icon_close`",
                          "tool-tip-value": _unref(t)('分納情報を展開する(詳細ページ)'),
                          onClick: ($event: any) => (_unref(store).expandPartialDelivery(index))
                        }, null, 8, ["tool-tip-value", "onClick"]))
                      : (item.status === _unref(OrderStatus).PartialDelivery && item.isExpanded)
                        ? (_openBlock(), _createBlock(SvgLoader, {
                            key: 1,
                            class: "editable-contents-item__expand-button",
                            name: 'arrowDown',
                            "data-testid": "`expand_icon_open`",
                            "tool-tip-value": _unref(t)('分納情報を閉じる(詳細ページ)'),
                            onClick: ($event: any) => (_unref(store).closePartialDelivery(index))
                          }, null, 8, ["tool-tip-value", "onClick"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14)),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(SelectOrderStatusField, {
                        class: "editable-contents-item__recommend-status",
                        index: index,
                        "model-value": item.status ?? _unref(OrderStatus).Recommended,
                        "onUpdate:modelValue": (e) => updateOrderStatus(index, e as OrderStatus)
                      }, null, 8, ["index", "model-value", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(getRecommendOrderDate(item)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(RecommendOrderField, {
                        class: "editable-contents-item__recommend-order-value",
                        "input-type": 'recommendValue',
                        "text-value": getOrderAmount(item),
                        "label-name": '',
                        onChangeText: ($event: any) => (changeText($event, index))
                      }, null, 8, ["text-value", "onChangeText"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(RecommendOrderField, {
                        class: "editable-contents-item__cross-date",
                        "input-type": 'recommendCrossDate',
                        "input-date": getRecommendCrossDate(index),
                        "label-name": '',
                        format: 'yyyy/MM/dd',
                        onChangeValue: ($event: any) => (setCrossDate(index, $event))
                      }, null, 8, ["input-date", "onChangeValue"])
                    ]),
                    _createVNode(TableMemoButton, {
                      class: "editable-contents-item__memo",
                      memo: getRecommendOrderNote(index),
                      "modal-coordinate-base": 'bottom-right',
                      "need-confirm-deletion": false,
                      onSave: 
                  (memoText) => {
                    updateMemoValue(index, memoText);
                  }
                ,
                      onDelete: 
                  () => {
                    updateMemoValue(index, '');
                  }
                
                    }, null, 8, ["memo", "onSave", "onDelete"]),
                    (item.isLocked)
                      ? (_openBlock(), _createBlock(SvgLoader, {
                          key: 3,
                          class: "editable-contents-item__lock-button",
                          name: 'lockClose',
                          "data-testid": "`lock_icon`",
                          "tool-tip-value": _unref(t)('入力値の固定を解除する(詳細ページ)'),
                          onClick: ($event: any) => (dispatchUnLockRecommend(index))
                        }, null, 8, ["tool-tip-value", "onClick"]))
                      : (_openBlock(), _createBlock(SvgLoader, {
                          key: 4,
                          class: "editable-contents-item__lock-button",
                          name: 'lockOpen',
                          "data-testid": "`lock_icon`",
                          "tool-tip-value": _unref(t)('入力値を固定する(詳細ページ)'),
                          onClick: ($event: any) => (dispatchLockRecommend(index))
                        }, null, 8, ["tool-tip-value", "onClick"])),
                    (visibleTrashBox(index))
                      ? (_openBlock(), _createBlock(SvgLoader, {
                          key: 5,
                          class: "editable-contents-item__trash-button",
                          name: 'trash-box',
                          "data-testid": "`trash_box_icon`",
                          "tool-tip-value": _unref(t)('項目を破棄する(詳細ページ)'),
                          onClick: ($event: any) => (dispatchTrashRecommend(index))
                        }, null, 8, ["tool-tip-value", "onClick"]))
                      : (_openBlock(), _createElementBlock("img", _hoisted_20))
                  ], 2),
                  (item.status === _unref(OrderStatus).PartialDelivery && item.isExpanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.partialDeliveryForms, (partialDeliveryItem, partialDeliveryIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: partialDeliveryIndex,
                            class: _normalizeClass(["editable-contents__content partial-delivery-contents-item", { 'locked-item': true }])
                          }, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
                            _cache[9] || (_cache[9] = _createElementVNode("div", null, null, -1)),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(SelectOrderStatusField, {
                                class: "partial-delivery-contents-item__recommend-status",
                                index: partialDeliveryIndex,
                                "model-value": partialDeliveryItem.status ?? _unref(OrderStatus).Recommended,
                                "is-show-arrow": false,
                                "onUpdate:modelValue": (e) => updateOrderStatus(partialDeliveryIndex, e as OrderStatus)
                              }, null, 8, ["index", "model-value", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(getRecommendOrderDate(partialDeliveryItem)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(RecommendOrderField, {
                                class: "partial-delivery-contents-item__recommend-order-value",
                                "input-type": 'recommendValue',
                                "text-value": getOrderAmount(partialDeliveryItem),
                                "label-name": '',
                                onChangeText: ($event: any) => (changeText($event, partialDeliveryIndex))
                              }, null, 8, ["text-value", "onChangeText"])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(RecommendOrderField, {
                                class: "partial-delivery-contents-item__cross-date",
                                "input-type": 'recommendCrossDate',
                                "input-date": getPartialDeliveryCrossDate(index, partialDeliveryIndex),
                                "label-name": '',
                                format: 'yyyy/MM/dd',
                                onChangeValue: ($event: any) => (setCrossDate(partialDeliveryIndex, $event))
                              }, null, 8, ["input-date", "onChangeValue"])
                            ]),
                            _createVNode(TableMemoButton, {
                              class: "partial-delivery-contents-item__memo",
                              memo: getRecommendOrderNote(partialDeliveryIndex),
                              "modal-coordinate-base": 'bottom-right',
                              "need-confirm-deletion": false,
                              onSave: 
                      (memoText) => {
                        updateMemoValue(partialDeliveryIndex, memoText);
                      }
                    ,
                              onDelete: 
                      () => {
                        updateMemoValue(partialDeliveryIndex, '');
                      }
                    
                            }, null, 8, ["memo", "onSave", "onDelete"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (recommendState.value === 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(TextButton, {
          class: "defined-order-container__add-text",
          "button-style": 'btn-secondary',
          "tool-tip-value": '',
          "on-click": addRecommend
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('発注を追加する(詳細ページ)')) + " ", 1),
            _createVNode(SvgLoader, {
              class: "defined-order-container__add-icon",
              name: 'plusIcon',
              "data-testid": "plus_icon"
            })
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    (_unref(store).state.progress === 'EditRecommend')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(TextButton, {
            class: "button-area__revise-button",
            "button-style": 'btn-secondary',
            "tool-tip-value": '',
            "on-click": onClickCancelButton
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('もどる')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(TextButton, {
            class: "button-area__confirm-button",
            "tool-tip-value": '',
            onClick: confirmRecommend
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('発注を登録')), 1)
            ], undefined, true),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})